import { ComboboxData } from 'ui';

import { isGroup } from './isGroup';

const flattenSearchData = (data: ComboboxData) => {
  return data.flatMap((item: ComboboxData[number]) => {
    if (isGroup(item)) {
      return item.items;
    }
    return item;
  });
};

export { flattenSearchData };
